export default {
    'type': 'نوع'
}